module.exports = __webpack_public_path__ + "static/media/14.4f7a1099.png";